<script lang="ts">
	import CardTip from '$lib/shared/ui/CardTip.svelte';
	import blue1 from '$img/blue-card-image1.avif';
	import blue2 from '$img/blue-card-image2.avif';
	import blue3 from '$img/blue-card-image3.avif';
	import pink1 from '$img/pink-card-image1.avif';
	import pink2 from '$img/pink-card-image2.avif';
	import pink3 from '$img/pink-card-image3.avif';

	// Decorative "tips coming in" cards that frame the hero. They live in the
	// side gutters and only appear from 2xl up, where the centered hero column
	// leaves enough room — below that they'd crowd or clip the headline.
	type FloatingCard = {
		side: 'left' | 'right';
		position: string;
		rotate: string;
		avatar: string;
		name: string;
		type: 'voice' | 'text';
		amount: string;
		received: string;
		tertiary: boolean;
		message: string;
	};

	const cards: FloatingCard[] = [
		{
			side: 'left',
			position: 'top-40 left-6',
			rotate: '-rotate-6',
			avatar: blue1,
			name: 'rune_owens',
			type: 'voice',
			amount: '$14.00',
			received: 'less than a minute ago',
			tertiary: false,
			message: 'Love the show! Keep up the great work!'
		},
		{
			side: 'left',
			position: 'top-[19rem] left-2',
			rotate: 'rotate-6',
			avatar: blue2,
			name: 'mossbyte',
			type: 'text',
			amount: '$8.50',
			received: 'less than a minute ago',
			tertiary: false,
			message: 'Amazing show!'
		},
		{
			side: 'left',
			position: 'top-[31rem] left-12',
			rotate: '-rotate-8',
			avatar: blue3,
			name: 'Dani Okafor',
			type: 'voice',
			amount: '$66.00',
			received: '10 minutes ago',
			tertiary: false,
			message:
				'Supporting your channel from way back. The content just keeps getting better and better!'
		},
		{
			side: 'right',
			position: 'top-36 right-6',
			rotate: 'rotate-6',
			avatar: pink1,
			name: 'kestrel.tv',
			type: 'voice',
			amount: '$23.00',
			received: '30 minutes ago',
			tertiary: true,
			message: 'Thank you for always providing such entertaining and informative shows. Keep it up!'
		},
		{
			side: 'right',
			position: 'top-[18rem] right-2',
			rotate: '-rotate-6',
			avatar: pink2,
			name: 'biscuit_jpg',
			type: 'text',
			amount: '$4.20',
			received: 'less than a minute ago',
			tertiary: true,
			message: 'Catch you tomorrow!'
		},
		{
			side: 'right',
			position: 'top-[30rem] right-12',
			rotate: 'rotate-8',
			avatar: pink3,
			name: 'Noor Haddad',
			type: 'voice',
			amount: '$19.00',
			received: 'less than a minute ago',
			tertiary: true,
			message: 'Keep stacking those wins! Wish I could be this good.'
		}
	];
</script>

{#each cards as card, i (card.name)}
	<!-- Float lives on the outer wrapper so it doesn't clobber the inner
	     rotate/scale transform. Negative stagger desyncs the bob. -->
	<div
		class="tip-float pointer-events-auto absolute hidden 2xl:block {card.position}"
		style="animation-delay: {i * -1.1}s;"
	>
		<div
			class="{card.rotate} {card.side === 'left'
				? 'origin-top-left'
				: 'origin-top-right'} scale-[0.58] transition duration-300 ease-in-out hover:scale-[0.62] 3xl:scale-[0.7] 3xl:hover:scale-[0.74]"
		>
			<CardTip
				nameStreamer={card.name}
				tipType={card.type}
				avatar={card.avatar}
				amount={card.amount}
				received={card.received}
				tertiary={card.tertiary}
			>
				{card.message}
			</CardTip>
		</div>
	</div>
{/each}

<style>
	@media (prefers-reduced-motion: no-preference) {
		.tip-float {
			animation: tip-float 6.5s ease-in-out infinite;
		}
		@keyframes tip-float {
			0%,
			100% {
				transform: translateY(0);
			}
			50% {
				transform: translateY(-9px);
			}
		}
	}
</style>
